import React, { useContext, useEffect } from "react"
import { ScrollView, Text, View } from "react-native"
import { textStyles } from "../style"
import { ThemeContext } from "../utility/context/ThemeContext"
import { useIsFocused } from "@react-navigation/native"

type WelcomeProps = { setStepHandler?: ((fn: undefined) => void) | undefined }

const Welcome: React.FC<WelcomeProps> = ({ setStepHandler }: WelcomeProps) => {
  const theme = useContext(ThemeContext).theme
  const { textMain } = theme.colors

  const isFocused = useIsFocused()

  useEffect(() => {
    if (isFocused && setStepHandler) {
      setStepHandler(undefined)
    }
  }, [isFocused, setStepHandler])

  /*
  const [playerWidth, setPlayerWidth] = useState(0)
  const maxPlayerWidth = 400
  const onPlayerContainerLayout = useCallback((e: LayoutChangeEvent) => {
    const width = Math.min(e.nativeEvent.layout.width, maxPlayerWidth)
    if (width !== playerWidth) setPlayerWidth(width)
  }, [playerWidth])

  const renderEmbedVideo = () => {
    const videoUrl = "https://www.youtube.com/embed/ScMzIvxBSi4?si=jhwIhiLa9xvK8YAs"
    return Platform.OS === "web" ? (
      <iframe
        src={videoUrl}
        title="Impact Banking Overview"
        allow=(
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        )
        allowFullScreen
        style={{ border: "none", width: "100%", maxWidth: 600, aspectRatio: 16/9 } }
      ></iframe>
    ) : (
      <View onLayout={onPlayerContainerLayout} style={{ width: "100%", alignItems: "center" }}>
        {playerWidth > 0 && (
          <View style={{ width: playerWidth, height: Math.round(playerWidth * 9 / 16) }}>
            <RNWebView
              source={{ uri: videoUrl }}
              style={{ width: "100%", height: "100%" }}
              javaScriptEnabled={true}
              domStorageEnabled={true}
              nestedScrollEnabled={false}
              scrollEnabled={false}
            />
          </View>
        )}
      </View>
    )
  }
  */
  
  return (
    <ScrollView 
      style={{ flex: 1 }}
      keyboardShouldPersistTaps="handled"
    >
      <View
        style={{gap: 20}}
        onStartShouldSetResponder={() => true}
      >
        <Text style={[textStyles.body, {color: textMain}]}> 
          Welcome to Impact Banking — your smarter, values-aligned way to bank.{" "}
          This quick onboarding will get you comfortable with Impact Banking and help you set up{" "}
          your profile and preferences so everything is tailored to your needs from day one.
        </Text>
        <Text style={[textStyles.body, {color: textMain}]}> 
          In just a few steps, you will personalize your experience, highlight what matters most,{" "}
          and unlock features designed around your goals.
        </Text>
        <Text style={[textStyles.body, {color: textMain}]}> 
          Ready to get started? Tap <Text style={{fontWeight: "bold"}}>Next</Text> to continue.{" "}
          Prefer to explore first? You can tap <Text style={{fontWeight: "bold"}}>Skip</Text> anytime from the header.
        </Text>
      </View>
    </ScrollView>
  )
}

export default Welcome